import { METHOD } from './method'

export const API_PAYROLL_NOTES = {
    LIST: {
        api: '/v1/hr-adm/payroll/notes',
        method: METHOD.GET,
    },
    DEPARTMENT_LIST: {
        api: '/v1/hr-adm/payroll/notes/department',
        method: METHOD.GET,
    },
    DIVISION_LIST: {
        api: '/v1/hr-adm/payroll/notes/division',
        method: METHOD.GET,
    },
    CREATE: {
        api: '/v1/hr-adm/payroll/notes',
        method: METHOD.POST,
    },
    UPDATE: {
        api: '/v1/hr-adm/payroll/notes',
        method: METHOD.PUT,
    },
    DELETE: {
        api: '/v1/hr-adm/payroll/notes',
        method: METHOD.DELETE,
    },
}
